/**
 * Custom hooks for authentication and authorization
 */
import { useUser } from '@clerk/clerk-react';

/**
 * Hook to check if the current user has admin role
 * @returns boolean indicating if the user is an admin
 */
export function useIsAdmin(): boolean {
  // Get user from Clerk hook (more reliable for React components)
  const { user } = useUser();

  // Check if user has admin role either from the hook or from window.Clerk
  // Define the expected metadata type
  type UserMetadata = { role?: string };

  return Boolean(
    // Check via Clerk hook first (preferred for React components)
    (user?.publicMetadata as UserMetadata)?.role === 'admin' ||
      // Fallback to direct window.Clerk check
      (typeof window !== 'undefined' &&
        window.Clerk?.user &&
        ((window.Clerk.user as any).publicMetadata as UserMetadata)?.role ===
          'admin')
  );
}
